// Heatlead analytics typed wrapper
declare global {
  interface Window {
    heatlead?: {
      track: (name: string, props?: Record<string, unknown>) => void;
      identify: (userId: string, traits?: Record<string, unknown>) => void;
    };
  }
}

export const hlTrack = (name: string, props?: Record<string, unknown>) => {
  try {
    window.heatlead?.track(name, props);
  } catch (e) {
    console.warn("heatlead track failed", e);
  }
};

export const hlIdentify = (userId: string, traits?: Record<string, unknown>) => {
  try {
    window.heatlead?.identify(userId, traits);
  } catch (e) {
    console.warn("heatlead identify failed", e);
  }
};
